// Ticket 42: a browser-side deadline for a database call.
//
// The database already cuts a query off on its own, by who is asking: 8 s for
// a signed-in reader and 3 s for a signed-out one (the live role settings for
// authenticated and anon, read from pg_roles on 13 Oct 2026; they are not in
// any migration, so the two numbers below are copies, to be updated by hand
// if those settings change, and nothing in the repo can check them). To read
// them again, in the Supabase SQL editor (read-only):
//   select rolname, rolconfig from pg_roles
//   where rolname in ('anon', 'authenticated', 'authenticator', 'postgres');
// On 13 Oct: anon statement_timeout=3s; authenticated statement_timeout=8s;
// authenticator statement_timeout=8s and lock_timeout=8s. That bounds a slow
// QUERY. It does nothing for a stalled connection, where the
// request never reaches the database at all, and nothing then ends the wait.
//
// This ends it. The browser's limit has to sit above the database's, for the
// same reason as every other pair in scripts/check-deadline-nesting.mjs: if
// the browser hung up first, the database's own cutoff could never be the one
// that ends the wait. So callers pass a limit above DB_CUTOFF_SIGNED_IN_MS.
//
// Usage, on a supabase-js query:
//   const deadline = queryDeadline(10000);
//   const { data, error } = await supabase.from(...).select(...).abortSignal(deadline.signal);
//   deadline.clear();
// An aborted call comes back as `error`, the same shape as any other failure,
// so each caller's existing error path is the one that runs.
//
// Put the abort ON the query (abortSignal), never inside the arguments of a
// database function call: a key that is not one of the function's arguments
// makes PostgREST look for a function that does not exist and refuse the call
// (PGRST202). That is exactly what broke process-trope's step 5 for seven weeks.

export const DB_CUTOFF_SIGNED_IN_MS = 8000;
export const DB_CUTOFF_SIGNED_OUT_MS = 3000;

export function queryDeadline(ms) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  return { signal: controller.signal, clear: () => clearTimeout(timer) };
}
